import { Invoice } from '../../types/Invoice';
import { InvoiceLog } from '../../types/invoiceLog';
import { InvoiceStatus } from '../../types/InvoiceStatus';
import { PaymentMethodDetails } from '../../types/PaymentDetails';
import { Payout } from '../../types/Payout';
import { PayoutsListingData } from '../../types/PayoutsListingData';
import { InvoicesListingFilters } from '../../types/requests/InvoicesListingFilters';
import { PayoutPreferencesRequest } from '../../types/requests/PayoutPreferencesRequest';
import { PayoutsListingRequest } from '../../types/requests/PayoutsListingRequest';
import { WithdrawlAgainstInvoicesRequest } from '../../types/requests/WithdrawlAgainstInvoicesRequest';
import { WithdrawlAgainstInvoicesResponse } from '../../types/responses/WithdrawlAgainstInvoicesResponse';

export abstract class IInvoiceManager {
  abstract updateLogoId(logoFileId: string): Promise<boolean>;
  abstract getInvoices(filters: InvoicesListingFilters): Promise<Invoice[]>;
  abstract getInvoiceById(invoiceId: string): Promise<Invoice>;
  abstract getInvoiceByPayoutId(payoutId: string): Promise<Invoice>;
  abstract getBankAccountByPayoutId(
    payoutId: string,
  ): Promise<PaymentMethodDetails>;
  abstract createWithdrawalAgainstInvoices(
    request: WithdrawlAgainstInvoicesRequest,
  ): Promise<WithdrawlAgainstInvoicesResponse>;
  abstract createInvoice(invoice: Partial<Invoice>): Promise<string>;
  abstract createInvoicePreview(
    invoice: Partial<Invoice>,
  ): Promise<{ success: boolean; data: Blob; error: string }>;
  abstract deleteInvoice(invoiceNo: string): Promise<boolean>;
  abstract updateInvoice(
    invoiceNo: string,
    sendCopyToUser: boolean,
  ): Promise<Invoice | null>;
  abstract sendAReminderForInvoice(invoiceNo: string): Promise<boolean>;
  abstract sendOverdueRemindersForInvoices(
    invoiceIds: string[],
  ): Promise<boolean>;
  abstract revokeInvoice(invoiceNo: string): Promise<boolean>;
  abstract updateInvoiceStatus(
    invoiceNo: string,
    status: InvoiceStatus,
  ): Promise<Invoice | null>;
  abstract duplicateInvoice(invoiceNo: string): Promise<Invoice | null>;
  abstract getInvoiceLog(invoiceNo: string): Promise<InvoiceLog | null>;
  abstract getPayouts(
    payoutsListingRequest: PayoutsListingRequest,
  ): Promise<PayoutsListingData>;
  abstract getPayoutsByPartner(
    filters: InvoicesListingFilters,
  ): Promise<Payout[]>;
  abstract updatePayoutPreferences(
    payoutPreferencesRequest: PayoutPreferencesRequest,
  ): Promise<boolean>;
  abstract updateInvoiceDueDate(
    invoiceNo: string,
    newDueDate: string,
  ): Promise<Invoice | null>;
}
